<template>
  <div>
    <v-img
      height=15
      src="../../assets/checkered_flag.gif"
    />
    <label class="v-label" style="top:20px; right: 30px; position: absolute; font-size: 10px;">
      * Phone Rentals - the number of phone calls that went to an agent through a ‘Sales’ queue plus calls that were dispositioned as “New Rental” but did not come through a ‘Sales’ queue.
    </label>
    <v-data-table
      :headers="headers"
      :items="agents"
      :loading="loading"
      hide-default-footer
      disable-pagination
      no-data-text="No agent data currently available. Something likely went wrong when this page was loading."
    >
      <template slot="headers" slot-scope="props">
        <tr>
          <th v-for="h in props.headers" :key="h.text" class="text-h6 font-weight-bold">{{ h.text }}</th>
        </tr>
      </template>
      <template slot="item" slot-scope="props">
        <tr :style="rowColor(props.item)">
          <td class="text-h4">
            <v-layout justify-center>
              {{ rank(props.item) }}
              <span class="subheading" v-if="rank(props.item) === 1">st</span>
              <span class="subheading" v-else-if="rank(props.item) === 2">nd</span>
              <span class="subheading" v-else-if="rank(props.item) === 3">rd</span>
              <span class="subheading" v-else>th</span>
            </v-layout>
          </td>
          <td>
            <v-layout justify-center>
              <v-icon size=40 v-if="rank(props.item) < props.item.user.previous_rank" class="success--text">
                arrow_upward
              </v-icon>
              <v-icon size=40 v-else-if="rank(props.item) > props.item.user.previous_rank" class="error--text">
                arrow_downward
              </v-icon>
              <v-icon size=40 v-else class="white--text">remove</v-icon>
            </v-layout>
          </td>
          <td>
            <v-layout column class="mt-3 mb-2" justify-center align-center>
              <v-avatar>
                <img :src="props.item.user.avatar_url">
              </v-avatar>
              <v-flex class="mt-1 text-caption">{{ props.item.user.first_name }} {{ props.item.user.last_name }}</v-flex>
            </v-layout>
          </td>
          <td class="text-h4">
            <v-layout justify-center>
              {{ props.item.ctm_sales_calls }}
            </v-layout>
          </td>
          <td class="text-h4">
            <v-layout justify-center>
              {{ props.item.s360_sales_calls }}
            </v-layout>
          </td>
          <td class="text-h4">
            <v-layout justify-center>
              {{ props.item.leads }}
            </v-layout>
          </td>
          <td class="text-h4">
            <v-layout justify-center>
              {{ props.item.reservations }}
            </v-layout>
          </td>
          <td class="text-h4">
            <v-layout justify-center>
              {{ props.item.phone_rentals }}
            </v-layout>
          </td>
          <td class="text-h4">
            <v-layout justify-center>
              {{ props.item.total_rentals }}
            </v-layout>
          </td>
          <td class="text-h4">
            <v-layout justify-center>
              {{ props.item.pending }}
            </v-layout>
          </td>
          <td class="text-h4">
            <v-layout justify-center>
              {{ props.item.ctm_effective_rate }}%
            </v-layout>
          </td>
          <td class="text-h4">
            <v-layout justify-center>
              {{ props.item.s360_effective_rate }}%
            </v-layout>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
/* eslint-disable eqeqeq */
import { effectiveRateHeaders } from "@/helpers/reporting/effective-rate-data-table-headers";

export default {
  data() {
    return {
      agents: [],
      loading: false,
      refreshInterval: null,

      headers: effectiveRateHeaders
    };
  },

  methods: {
    rank(agent) {
      return this.agents.indexOf(agent) + 1;
    },

    rowColor(agent) {
      if (this.rank(agent) == 1) {
        return "box-shadow: inset 0px 0px 10px 4px #ffe16a;background: #ffe16a78;";
      } else if (this.rank(agent) == 2) {
        return "box-shadow: inset 0px 0px 10px 4px #d9d9d9;background: #d9d9d952;";
      } else if (this.rank(agent) == 3) {
        return "box-shadow: inset 0px 0px 10px 4px #e1b283;background: #e1b28375;";
      } else {
        return "";
      }
    },

    getEffectiveRate() {
      this.loading = true;
      this.$store.dispatch("getEffectiveRate")
        .then(resp => {
          this.agents = resp.data;
          this.loading = false;
        })
        .catch(err => {
          this.$store.dispatch("handleError", err);
          this.loading = false;
        });
    }
  },

  created() {
    this.getEffectiveRate();
    this.$store.dispatch("startSession"); // this refreshes the token in the background so we don't timeout on auth

    this.refreshInterval = setInterval(this.getEffectiveRate, 1000 * 60 * 60);
  }
};

</script>
